import { render, staticRenderFns } from "./se2a-admin-unit-index.vue?vue&type=template&id=46e04856&scoped=true"
import script from "./se2a-admin-unit-index.vue?vue&type=script&lang=js"
export * from "./se2a-admin-unit-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e04856",
  null
  
)

export default component.exports